"use client";
import { useState } from "react";
import { Button } from "@/components/Button/Button";
import { Layout } from "@/components/Layout/Layout";
import { AwardCard } from "@/components/AwardCard/AwardCard";
import { HeroBanner } from "@/components/HeroBanner/HeroBanner";
import { Paragraph } from "@/components/Paragraph/Paragraph";
import HTMLReactParser from "html-react-parser";
import { getImageSrc } from "@/app/utils/getImageSrc";
import { Timeline } from "@/components/Timeline/Timeline";
const initialAwardList = 9;
const incrementInitialAwardList = 9;

export default function Wrapper({ pageData, awardsList }) {
	const [displayAwards, setDisplayAwards] = useState(initialAwardList);
	const [awards, setAwards] = useState(awardsList);

	const loadMore = () => {
		setDisplayAwards(displayAwards + incrementInitialAwardList);
	};

	return (
		<Layout>
			<HeroBanner image={getImageSrc(pageData.banner.image.url)} title={HTMLReactParser(pageData.banner.title)} about={HTMLReactParser(pageData.banner.text)} mobileImage={getImageSrc(pageData.banner.mobileImage.url)} alt={pageData.banner.image?.alt || "Hindustan Power awards and recognition"} mobileAlt={pageData.banner.mobileImage?.alt || "Hindustan Power awards and recognition"} />
			<section className="py-8 lg:py-16 ">
				<div className="flex flex-col items-center gap-8">
					<div className="hp-container flex flex-col items-center">
						<div className="text-center flex flex-col gap-2 mb-5 md:max-w-[80%] xl:max-w-[60%]">
							<Paragraph>{HTMLReactParser(pageData.intro.text)}</Paragraph>
						</div>
					</div>

					<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-5 lg:gap-8 w-full hp-container">
						{awards.slice(0, displayAwards).map((award) => (<AwardCard key={award.id} award={award} />))}
					</div>
					<div className="">
						{displayAwards < awards.length ? (
							<button className="bg-primary text-white py-2.5 px-8 lg:px-12 rounded-[20px] inline-block font-medium text-[14px] lg:text-[16px] xl:text-[18px] " onClick={loadMore}>View More</button>
						) : null}
					</div>
				</div>
			</section>
		</Layout>
	);
}
